import { HomeComponent } from './home/home.component';
import { homeChildRoutes } from './home/searchHome.routing';

export const ResultChildRoutes = [
  {
    path: '',
    component: HomeComponent,
    children: homeChildRoutes,
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '/search/driver',
  },
];
